import { useState, useTransition } from 'react';

import { cn } from 'src/lib/utils';
import { type IOwnershipFilter } from 'src/containers/Home/model';
import { OwnershipFilterSelect } from 'src/containers/Home/ui';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

import AssuranceSummary from './AssuranceSummary';

const AssuranceCard = () => {
  const [ownershipFilter, setOwnershipFilter] = useState<IOwnershipFilter>('all');
  const [isFilterPending, startFilterTransition] = useTransition();

  const handleOwnershipFilterChange = (value: IOwnershipFilter) => {
    startFilterTransition(() => setOwnershipFilter(value));
  };

  return (
    <Card>
      <CardHeader className="gap-1.5 space-y-0 p-6 pb-3">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
          <CardTitle>Assurance</CardTitle>
          <OwnershipFilterSelect
            value={ownershipFilter}
            onValueChange={handleOwnershipFilterChange}
            aria-label="Filter assurance by applications"
          />
        </div>
        <CardDescription>
          Proof your software protection works. Each level includes additional checks to strengthen your resilience:
          complete, current, recoverable.
        </CardDescription>
      </CardHeader>
      <CardContent
        data-testid="assurance-summary-area"
        aria-busy={isFilterPending}
        className={cn('p-6 pt-3 transition-opacity', isFilterPending && 'opacity-60')}
      >
        <AssuranceSummary ownershipFilter={ownershipFilter} />
      </CardContent>
    </Card>
  );
};

export default AssuranceCard;
